//数学函数--11个
export const MathFunc = [
  {
    "key": "NumberThousandSeparator",
    "name": "数字千位分隔",
    "params": [
      {
        "key": "property",
        "name": "数字类型字段",
        "type": "int32"
      }
    ],
    "description": `【功能】对数字添加千位分割符，以逗号作为千位分隔符
【参数】
  【property】字段（链式结构）
【返回值】字符型
【示例】
  【场景】提交单据Order，单据包含总费用totalCost
  【需求】优化总费用展示，对总费用添加千位分隔符
  【举例】数字千位分隔(Order.totalCost)
  【返回值】1,234,567.89`,
    "type": "Math",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "abs",
    "name": "绝对值",
    "params": [
      {
        "key": "value",
        "name": "数值",
        "type": "double"
      }
    ],
    "description": `【功能】：返回一个数值的绝对值\n【返回值类型】：数值(Double)\n【示例】：绝对值(-1.5)【返回值】：1.5`,
    "type": "Math",
    "keyFront": "Math",
    "className": ""
  },
  {
    "key": "Round",
    "name": "四舍五入"
  },
  {
    "key": "round",
    "name": "四舍五入",
    "params": [
      {
        "key": "value1",
        "name": "数值",
        "type": "double"
      },
      {
        "key": "value2",
        "name": "小数位数",
        "type": "int32"
      }
    ],
    "description": `【功能】：根据小数位数精度，对数值四舍五入\n【value1】：数值\n【value2】：四舍五入小数位数\n【返回值类型】：数值(Double)\n【示例】：四舍五入(1.52,1)【返回值】：1.5`,
    "type": "Math",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "random",
    "name": "随机数",
    "params": [],
    "description": `【功能】：随机生成大于等于 0.0 且小于 1.0 的伪随机值\n【返回值类型】：数值(Double)\n【示例】：随机数()【返回值】：0.624508349393`,
    "type": "Math",
    "keyFront": "Math",
    "className": ""
  },
  {
    "key": "sin",
    "name": "正弦",
    "params": [
      {
        "key": "value",
        "name": "数值",
        "type": "double"
      }
    ],
    "description": `【功能】：返回一个数字的正弦值\n【返回值类型】：数值(Double)一个以弧度表示的角\n【示例】：正弦(1)【返回值】：0.84187098`,
    "type": "Math",
    "keyFront": "Math",
    "className": ""
  },
  {
    "key": "cos",
    "name": "余弦",
    "params": [
      {
        "key": "value",
        "name": "数值",
        "type": "double"
      }
    ],
    "description": `【功能】：返回一个数字的余弦值\n【返回值类型】：数值(Double)一个以弧度表示的角\n【示例】：余弦(3)【返回值】：-0.9899924`,
    "type": "Math",
    "keyFront": "Math",
    "className": ""
  },
  {
    "key": "ceil",
    "name": "向上舍入",
    "params": [
      {
        "key": "value",
        "name": "数值",
        "type": "double"
      }
    ],
    "description": `【功能】：返回大于或等于函数参数，并且与之最接近的整数\n【返回值类型】：数值(Int32)\n【示例】：向上舍入(3.2)【返回值】：4`,
    "type": "Math",
    "keyFront": "Math",
    "className": ""
  },
  {
    "key": "floor",
    "name": "向下舍入",
    "params": [
      {
        "key": "value",
        "name": "数值",
        "type": "double"
      }
    ],
    "description": `【功能】：返回小于或等于函数参数，并且与之最接近的整数\n【返回值类型】：数值(Int32)\n【示例】：向下舍入(3.2)【返回值】：3`,
    "type": "Math",
    "keyFront": "Math",
    "className": ""
  },
  {
    "key": "BankerRound",
    "name": "银行家舍入"
  },
  {
    "key": "bankerRound",
    "name": "银行家舍入",
    "params": [
      {
        "key": "value1",
        "name": "数值",
        "type": "double"
      },
      {
        "key": "value2",
        "name": "小数位数",
        "type": "int32"
      }
    ],
    "description": `【功能】：使用银行家舍入标准，把指定数字舍入为最接近的数字\n【value1】：舍入数值\n【value2】：舍入小数位数\n【返回值类型】：数值(Double)\n【示例】：银行家舍入(36.124,2)【返回值】：36.12`,
    "type": "Math",
    "keyFront": "DefaultFunction",
    "className": ""
  }
]